/**
 * DateSeparator — заголовок между группами карточек по дате (Phase 4).
 *
 * Format: «11 марта, 2026».
 */

import { formatGalleryDate } from '../../utils/dateFormat';

export function formatDateLabel(isoString) {
  return formatGalleryDate(isoString);
}

export default function DateSeparator({ isoDate }) {
  const label = formatDateLabel(isoDate);
  return (
    <div
      className="font-sans text-[16px] font-bold leading-tight text-text-secondary py-2"
      data-testid="date-separator"
      data-iso={isoDate}
    >
      {label}
    </div>
  );
}
